import React from "react";
import {
  AHIcon,
  AHIconType,
  AHText,
  Box,
  Circle,
  ColorType,
  Space,
  useLayoutContext,
  useTheme,
} from "arkh";
import { Pressable, PressableProps, ViewStyle } from "react-native";
import Color from "color";

export function OutlinedHeaderButton(
  props: {
    onPress: () => void;
    onPressIn?: () => void;
    icon?: AHIconType;
    title?: React.ReactNode;
    backgroundColor?: string;
    tintColor?: ColorType;
    containerStyle?: ViewStyle;
    spaceLeft?: Space;
    spaceRight?: Space;
  } & Pick<PressableProps, "hitSlop" | "pressRetentionOffset">
) {
  const theme = useTheme();
  const backgroundColor =
    props.backgroundColor ?? theme["surface-backgroundControl"];
  const tintColor = props.tintColor ?? "primary";
  const layout = useLayoutContext();
  return (
    <Pressable
      onPressIn={props.onPressIn}
      hitSlop={props.hitSlop}
      pressRetentionOffset={props.pressRetentionOffset}
      onPress={props.onPress}
      style={[
        {
          height: "100%",
          justifyContent: "center",
          alignItems: "center",
          paddingLeft: layout.space[props.spaceLeft ?? "none"],
          paddingRight: layout.space[props.spaceRight ?? "none"],
        },
        props.containerStyle,
      ]}
    >
      {({ pressed }) => (
        <Box
          style={{
            backgroundColor: pressed
              ? Color(backgroundColor).alpha(0.3).toString()
              : backgroundColor,
            height: layout.circle.medium,
            width: !props.title ? layout.circle.medium : undefined,
            borderRadius: layout.circle.medium / 2,
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {props.title ? (
            <AHText
              spaceLeft="medium"
              spaceRight={props.icon ? "none" : "medium"}
              type="subtitle"
              color={tintColor}
            >
              {props.title}
            </AHText>
          ) : null}
          {props.icon ? (
            <Circle
              size="medium"
              style={{ justifyContent: "center", alignItems: "center" }}
            >
              <AHIcon type={props.icon} size="medium" color={tintColor} />
            </Circle>
          ) : null}
        </Box>
      )}
    </Pressable>
  );
}
